import React, {Component} from 'react';
import '../css/TotalMembers.css';
import {Link} from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import localStorage from 'local-storage';
import Dropdown from 'react-dropdown';
import * as CurrencyFormat from 'react-currency-format';
import _adviserPortalHome from './_adviserPortalHome';
import { sort } from '@amcharts/amcharts4/.internal/core/utils/Iterator';
import { prettyDOM } from '@testing-library/react';
import {CSVLink} from 'react-csv';

class TotalMembersComponent extends Component{

    constructor(props){
        super(props);
        const filter = {
            contributing:"All",
            adviser: "All",
            searchString: ""
        }
        this.state={
            loading: true,
            id: null,
            searchResult: [], //For handling search members results -- only used when search bar is not null
            totalMembers: [],
            contributorsFiltered: [],
            memberList: [],
            sortedMembers:[],
            displayedMembers: [],
            memberListLoaded: false,
            filter: filter,
            sortColumn: null,
            sortOrder:1,
            getProductSpecificMembers: this.getProductSpecificMembers.bind(this)
        }
    }

    static getDerivedStateFromProps(props, state){
        let id = null;
        // id = !props.id.length <= 1 ? props.id.map(id => id) : props.id
        id = props.id
        if(state.memberList !== props.memberList){
            if(!props.match.params.product){
                return {
                    memberList: props.memberList,
                    id: id
                }
            }
            else {
                return {
                    memberList: state.totalMembers,
                    id: id
                }
            }
        }
        
        if(state.searchResult && state.searchResult.length === 0){
            if(!document.getElementById("searchMember").value){ 
            // If no member search going on
                if(state.contributorsFiltered && state.contributorsFiltered.length !== 0){
                    return {
                        searchResult: state.contributorsFiltered
                    }                    
                }else {
                    return {
                        searchResult: state.memberList,
                    }
                }
                    
                }
            else {
                return {
                    searchResult: state.searchResult //searchResult = handleSearch result
                }
            }
        }
        else{
            if(state.memberList !== props.memberList){
            // If memberList state is updated
                if(state.contributorsFiltered && state.contributorsFiltered.length !== 0){
                    return {
                        searchResult: state.contributorsFiltered
                    }
                }else{
                    return {
                        searchResult: state.memberList,
                    }
                }
            }
            else{
                return{
                    searchResult: state.searchResult
                    
                }
            }
              
        } 
    }
    
    componentDidMount(){
        localStorage.clear();
        // this.props.startLoadingMembers(this.props.selectedAdviserId ? this.props.selectedAdviserId : this.state.id)
        // this.props.startLoadingMembers(this.state.id);
        // this.state.product && this.getProductSpecificMembers(this.state.product)
        // this.setState({loading: false})
    }

    componentDidUpdate(prevProps, prevState){
        // Populate the member list
        if(!this.state.memberListLoaded){
            if (this.props.memberList && this.props.memberList.length > 0){
                this.setState({memberListLoaded: true})
            }else if (this.props.memberList && this.props.memberList.length === 0){
                this.props.startLoadingMembers(this.state.id)
                this.setState({memberListLoaded: true})
            }
        }

        let displayedMembers = []

        //Re-generate the member list based on the product
        if (prevProps.match.params.product !== this.props.match.params.product){
            this.getProductSpecificMembers(this.props.match.params.product);
            document.getElementById("searchMember").value = ""
            this.setState({
                searchResult:[],
                sortedMembers:[],
                sortColumn: null,
                contributorsFiltered: [],
                filter: {contributing : "All",adviser: "All", searchString:""}
            })
        }
          
        // Set search Result based on the existing memberList
        // [TODO]
        if(prevProps.memberList !== this.props.memberList){
            if(!this.state.totalMembers){
                this.setState({searchResult: this.props.memberList})
            }
            else{
                this.setState({searchResult: this.state.totalMembers})
                this.getProductSpecificMembers(this.props.match.params.product);
            }
        }

        //[TODO]
        if(this.props.memberList && this.props.memberList.length !== 0){
            
            if(JSON.stringify(prevState.filter)  !== JSON.stringify(this.state.filter)){
                this.filterMembers()
            }

            if(this.props.match.params.product){
                displayedMembers = this.props.memberList.filter(member => 
                    member.scheme === this.props.match.params.product).map(member => member)
            }
            if(this.state.sortedMembers && this.state.sortedMembers.length > 0){
                displayedMembers = this.state.sortedMembers
            }else {
                if(this.state.searchResult && this.state.searchResult.length !== 0){
                    displayedMembers = this.state.searchResult;
                }
                
                else{
                    if(document.getElementById("searchMember") && !document.getElementById("searchMember").value){
                        displayedMembers = this.state.memberList
                    }
                    else if(document.getElementById("searchMember") && document.getElementById("searchMember").value){

                    }
                    else if(this.state.totalMembers.length!==0){
                        displayedMembers = this.state.totalMembers
                    }
                    else{
                        displayedMembers = []
                    }
                }
            }        
        }

        if(displayedMembers.length > 0 && JSON.stringify(this.state.displayedMembers) !== JSON.stringify(displayedMembers)){
            this.setState({displayedMembers:displayedMembers})
        }
    }

    getProductSpecificMembers(product){
        this.setState({
            totalMembers: this.props.memberList && this.props.memberList.filter(member => 
                member.scheme === product).map(member => member)
        })
    }

    handleSearch(e){
        this.setState({
            filter: {...this.state.filter, searchString: e.target.value}
        })
           
    }

    _onSelect(e, id){
        if(!e)
            e = {
                label: "All",
                value: "all"
            }
        if (id){
            switch (id){
                case "adviserDropdown":
                    this.setState({
                        filter: {...this.state.filter, adviser: e.value}
                    })
                    break;
                case "contributionDropdown":
                    this.setState({
                        filter: {...this.state.filter, contributing: e.value}
                    })
                    break;
                default:
            }

        }
    }

    //[TODO] Rework the whole filtering system
    filterMembers(){
        let totalMembers = [];

        this.state.memberList.map(member => totalMembers.push(member))
        
        if(this.state.filter.adviser !== "All"){
            totalMembers = [...totalMembers].filter(member => 
                this.state.filter.adviser.toLowerCase().includes(member.adviserFirstName.toLowerCase()) && 
                this.state.filter.adviser.toLowerCase().includes(member.adviserLastName.toLowerCase())
                ).map(member => member)
        }

        if(this.state.filter.contributing !== "All"){
            totalMembers = [...totalMembers].filter(member => 
                member.hasContributions === this.state.filter.contributing).map(member => member)
        }

        if (this.state.filter.searchString !== ""){
            const memberName = this.state.filter.searchString
            totalMembers = [...totalMembers].filter(member =>
                member.firstName.toLowerCase().includes(memberName.toLowerCase()) ||
                member.lastName.toLowerCase().includes(memberName.toLowerCase()) ||
                (member.firstName.toLowerCase() + " " + member.lastName.toLowerCase()).includes(memberName.toLowerCase()))
                .map(member => member)
        }
        
        this.setState({contributorsFiltered: totalMembers, searchResult: totalMembers,
                        sortedMembers: [], sortColumn: null})
    }

    _loadMember(usrMemberSetId) {
        this.props.startLoadingMemberDetails(usrMemberSetId);
        this.props.startLoadingAccountBalances(usrMemberSetId);
        this.props.startLoadingFundBalances(usrMemberSetId);
        this.props.startLoadingAccountReturns(usrMemberSetId);
        this.props.startLoadingFundReturns(usrMemberSetId);
        this.props.startLoadingMemberContribution(this.state.usrMemberSetId);
    }

    _sortBy(e){
        const id = e.target.id;
        if (id==="sortName"){
            if (this.state.displayedMembers && this.state.displayedMembers.length!==0){
                if(this.state.sortColumn === id){
                    this.setState({
                        sortedMembers: [...this.state.displayedMembers].reverse(),
                        sortOrder:this.state.sortOrder*-1
                    })
                } else {
                    this.setState({
                        sortedMembers: [...this.state.displayedMembers].sort((a,b) => a.firstName.localeCompare(b.firstName)),
                        sortColumn: id,
                        sortOrder:1
                    })
                }
            }
        }else if(id === "sortBalance"){
            if (this.state.displayedMembers && this.state.displayedMembers.length!==0){
                if(this.state.sortColumn === id){
                    this.setState({
                        sortedMembers: [...this.state.displayedMembers].reverse(),
                        sortOrder:this.state.sortOrder*-1
                    })
                } else {
                    this.setState({
                        sortedMembers: [...this.state.displayedMembers].sort((a,b) => a.fum - b.fum),
                        sortColumn: id,
                        sortOrder:1
                    })
                }
            }
        }else if(id === "sortProduct"){
            if (this.state.displayedMembers && this.state.displayedMembers.length!==0){
                if(this.state.sortColumn === id){
                    this.setState({
                        sortedMembers: [...this.state.displayedMembers].reverse(),
                        sortOrder:this.state.sortOrder*-1
                    })
                } else {
                    this.setState({
                        sortedMembers: [...this.state.displayedMembers].sort((a,b) => a.schemeName.localeCompare(b.schemeName)),
                        sortColumn: id,
                        sortOrder:1
                    })
                }
            }
        }
    }

    render(){
        const {t} = this.props;
        const options = [
           {
               label: "All",
               value: "All"
           },
           {
               label: "Yes",
               value: "Y"
           },
           {
               label: "No",
               value: "N"
           }
          ];
        let advisers =  ["All"]
        this.props.advisers.map((adviser)=> {
            advisers.push(
                adviser.adviserName
            )
        })
        return(
            //style={{margin: "20px", paddingLeft: "100px"}}
            <div className="totalMembers">
                <header className="adviserMenu">
                    <table className="totalMembersHeader">
                        <thead>
                            <tr>
                            <th>{t('Members:header')}</th>
                            <th>
                                <input className="totalMembersHeader" id="searchMember" type="text" placeholder="Search Member" onChange={e => this.handleSearch(e)}></input>
                            </th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr>
                                <td className='rightAligned'>{t('membersTable:contributing')}</td>
                                <td>
                                    <Dropdown controlClassName="dropdown-box-totalMembers" 
                                    id="contributionDropdown"
                                    menuClassName="dropdown-contents-totalMembers" 
                                    arrowClassName="dropdown-arrow-totalMembers"
                                    options={options} 
                                    onChange={ e => this._onSelect(e, "contributionDropdown")}
                                    value={this.state.filter.contributing} placeholder="Select an option" arrowOpen={true}/>
                                </td>
                            </tr>
                            <tr>
                                <td className='rightAligned'>{t('membersTable:adviser')}</td>
                                <td>
                                    <Dropdown controlClassName="dropdown-box-totalMembers"
                                    id="adviserDropdown" 
                                    menuClassName="dropdown-contents-totalMembers-adviser" 
                                    arrowClassName="dropdown-arrow-totalMembers"
                                    options={advisers} 
                                    onChange={ e => this._onSelect(e, "adviserDropdown")}
                                    value={this.state.filter.adviser} placeholder="Select an option" arrowOpen={true}/>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2} className='rightAligned'>
                                    <button className="refresh" id="export">
                                    <CSVLink className="link" style={{paddingLeft:"5px", color: "white"}}
                                        filename="Member List.csv" 
                                        data={this.state.displayedMembers}>{t('adviserHomePage:export')}
                                    </CSVLink>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {/* </div> */}
                </header>
                {/* <header className="adviserMenu" style={{textAlign: "left"}}>{t('total')+" "+t('member')+'s'}
                    <div style={{paddingLeft: "12px", display: "inline", float:"right"}}>
                        <input type="text" placeholder="Search Member" onChange={e => this.handleSearch(e)}></input>
                    </div>
                </header> */}
                
                <table id="totalMembers" className="totalMembers superlifeLegacyPlan">
                    <thead>
                        <tr>
                            <th style={{verticalAlign: "top"}}>{t('membersTable:name')} 
                                <img src= {(this.state.sortColumn === "sortName" && this.state.sortOrder !== 1) ? "/adviser/images/arrow_sorting_1.png":"/adviser/images/arrow_sorting_2.png"} 
                                width="12" id="sortName" onClick={e => this._sortBy(e)} style={{cursor:"pointer"}}/>
                            </th>
                            <th style={{textAlign: "center", verticalAlign: "top"}}>{t('membersTable:product')} 
                                <img src= {(this.state.sortColumn === "sortProduct" && this.state.sortOrder !== 1) ? "/adviser/images/arrow_sorting_1.png":"/adviser/images/arrow_sorting_2.png"} 
                                width="12" id="sortProduct" onClick={e => this._sortBy(e)} style={{cursor:"pointer"}}/>
                            </th>
                            <th style={{textAlign: "center", verticalAlign: "top"}}>{t('membersTable:balance')} 
                                <img src= {(this.state.sortColumn === "sortBalance" && this.state.sortOrder !== 1) ? "/adviser/images/arrow_sorting_1.png":"/adviser/images/arrow_sorting_2.png"} 
                                width="12" id="sortBalance" onClick={e => this._sortBy(e)} style={{cursor:"pointer"}}/>
                            </th>
                            <th style={{textAlign: "center", verticalAlign: "top"}}>{t('membersTable:contributing')}<br/>{this.state.filter.contributing}</th>
                            <th style={{textAlign: "center", verticalAlign: "top"}}>{t('membersTable:adviser')}<br/>{this.state.filter.adviser}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.displayedMembers && this.state.displayedMembers.length!==0 ? this.state.displayedMembers.map((member, index) => 
                            <tr key={index}>
                                <td style={{textAlign: "left"}}>
                                    <Link className="link" style={{color: "#51820F",fontWeight: "500"}}
                                    to={`/adv/memberSite/${member.usrMemberSetId}/personalDetails/summary`} 
                                    onClick={() => this._loadMember(member.usrMemberSetId)}>
                                            {member.firstName}{' '}{member.lastName}</Link></td>
                                <td style={{textAlign: "center"}}>{member.schemeName}</td>
                                <td style={{textAlign: "right"}}>
                                    <CurrencyFormat  value={Number(member.fum).toFixed(2)}
                                        displayType={'text'} 
                                        thousandSeparator={true} 
                                        prefix={'$'}/>
                                </td>
                                <td style={{textAlign: "center"}}>{member.hasContributions === "Y" ? "Yes" : "No"}</td>
                                <td style={{textAlign: "center"}}>{member.adviserFirstName}{' '}{member.adviserLastName}</td>
                            </tr>) : <tr><td>{t('fetching')+" "+t('member')}s....</td></tr>
                    }
                    </tbody>
                </table>

            </div>
        )
    }
}

export default withTranslation()(TotalMembersComponent);